module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Splash.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-3"
  }, [_c('p', {
    staticClass: "quote2"
  }, [_c('span', {
    staticClass: "quote-small-caps",
    staticStyle: {
      "font-size": "1.1em"
    }
  }, [_vm._v("Live each season")]), _c('span', {
    staticClass: "quote-small-caps"
  }), _vm._v("as it passes; breathe the air, drink the drink, taste the fruit, and resign yourself to the influences of each.")]), _vm._v(" "), _c('p', {
    staticClass: "quotee2"
  }, [_vm._v("Henry David Thoreau ")]), _vm._v(" "), _c('p', {
    staticClass: "swoosh"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "238.jpg",
      "src": "images/238.jpg",
      "width": "10%"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03a42de6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Splash.vue
// module id = 57
// module chunks = 0